import type { AmplitudeInstance } from '.';
import { APP_ENV } from '../../config';

export interface Ids {
  deviceId: string | undefined;
  sessionId: number | undefined;
  userId: string | undefined;
}

export const getIds = (amplitude?: AmplitudeInstance): Ids => {
  if (!amplitude) {
    if (APP_ENV === 'qa')
      console.log(
        'Amplitude not initialised or instance not found - unable to log event with timestamp',
      );
    return {
      deviceId: undefined,
      sessionId: undefined,
      userId: undefined,
    };
  }
  return {
    deviceId: amplitude.getDeviceId(),
    sessionId: amplitude.getSessionId(),
    userId: amplitude.getUserId(),
  };
};
